<div class="qb-receipt">
    <lazy-component moduleUri="@lazy-modules-module/receiptHeader/receipt-header.module#ReceiptHeaderModule" [inputs]="{ betDate: betReceipt.date }">
    </lazy-component>

    <!-- Trending Bets Carousel Module-->
    @if (selection && trendingBetsConfigData && trendingBetsConfigData.isQuickBetReceiptEnabled && isMobile && selection.categoryId === '16') {
        <lazy-component
            moduleUri="@lazy-modules-module/trending-bets-carousel/trending-bets-carousel.module#TrendingBetsCarouselModule"
            entryComponent="TrendingBetsCarouselComponent"
            [inputs]="{
                trendingBetsConfigData: trendingBetsConfigData,
                eventLocation: 'quick bet receipt',
                quickBetSelectionId:
                    selection.markets && selection.markets.length && selection.markets[0].outcomes.length && selection.markets[0].outcomes[0].id,
            }">
        </lazy-component>
    }
    @if (racingPostData && enableRacingPostTip()) {
        <lazy-component
            moduleUri="@lazy-modules-module/racingPostTip/racing-post-tip.module#RacingPostTipModule"
            [inputs]="{
                quickBetReceipt: selection,
                racingPostData: racingPostData,
                racingPostToggle: racingPostToggle,
                isNextRacesData: isNextRacesData,
            }"
            [outputs]="['racingPostGTM']"
            (event)="onRacingPostGTMEvent($event)">
        </lazy-component>
    }
    @if (showEntryConfirmation?.showdown) {
        <lazy-component
            moduleUri="@lazy-modules-module/fiveASideShowDown/fiveaside-entry-confirmation.module#FiveASideEntryConfirmationModule"
            [inputs]="{
                entryTitle: 'fs.entryinfo.entryTitle',
                ecText: showEntryConfirmation?.ecText,
                contestId: showEntryConfirmation?.contestId,
                termsConditionTag: showEntryConfirmation?.termsConditionTag,
            }"
            entryComponent="FiveASideEntryConfirmationComponent">
        </lazy-component>
    }
    @if (!showEntryConfirmation?.showdown && !betReceipt.selections) {
        <div class="qb-reuse">
            <span class="qb-reuse-yourbets" [textContent]="YOUR_BETS"></span>
            @if (showReuse) {
                <span class="qb-reuse-button-wrapper">
                    <strong class="qb-reuse-button" [textContent]="REUSE" (click)="reuseBets()"></strong>
                </span>
            }
        </div>
    }
    <div class="qb-receipt-wrapper">
        @if (betReceipt.oddsBoost) {
            <div class="qb-stake-boosted">
                <svg class="qb-boosted-icon">
                    <use xlink:href="#odds-boost-icon-dark"></use>
                </svg>
                <span class="qb-boosted-text" [i18n]="'bs.boostedMsg'"></span>
            </div>
        }
        @if (!betReceipt.selections) {
            <div class="qb-stake-header">
                <div class="line">
                    <div class="left">
                        <div class="qb-stake-info">
                            <strong class="selection-type" [textContent]="filteredOutcomeName" data-crlat="selType"></strong>&nbsp;
                            <strong class="qb-single-receipt-odds" [textContent]="'@ '"></strong>
                            <strong class="qb-single-receipt-odds" [textContent]="odds" data-uat="odds" data-crlat="odds"></strong>
                            <div class="receipt-id">
                                <span [i18n]="'quickbet.betId'" data-crlat="betId.label"></span>
                                <span [textContent]="betReceipt.receipt.id" data-uat="betId" data-crlat="betId.value"></span>
                            </div>
                            <div [ngClass]="{ epr: filteredOutcomeName.length < 28 }">
                                <lazy-component
                                    moduleUri="@lazy-modules-module/extraPlaceSignposting/extra-place-signposting.module#ExtraPlaceSignpostingModule"
                                    [inputs]="{ marketData: selection.markets[0], origin: 'quickbetreceipt' }"
                                    entryComponent="ExtraPlaceSignpostingComponent">
                                </lazy-component>
                            </div>
                            <div>
                                <span class="qb-stake-type" [textContent]="filteredMarketName + ' / '" data-uat="marketName"></span>
                                <span class="qb-stake-description" [textContent]="filteredEventName" data-uat="eventName"></span>
                            </div>
                        </div>
                    </div>
                    <div class="right-section">
                        @if (isSportIconEnabled) {
                            <div class="sports-icon" [ngClass]="{ 'sports-icon-wrapper': winAlertsEnabled }">
                                <svg class="sports-icon-position">
                                    <use [attr.xlink:href]="'#' + sportIconSvgId"></use>
                                </svg>
                            </div>
                        }
                    </div>
                </div>
                @if (isEachWay) {
                    <div class="eachway-terms-block">
                        @if (eachEayTerms) {
                            <span class="eachway-terms" [textContent]="eachEayTerms" data-crlat="ewPlaces"></span>
                        }
                        <span class="eachway-terms" [textContent]="linesPerStake" data-crlat="ewLines"></span>
                    </div>
                }
            </div>
        }
        @if (betReceipt.selections) {
            <div class="qb-stake-header" data-crlat="quickbet.content">
                <div class="line">
                    <div class="left">
                        <div class="qb-stake-info">
                            <strong class="selection-type" [textContent]="bybSelectionType" data-crlat="selType"></strong>&nbsp;
                            <strong class="qb-single-receipt-odds" [textContent]="'@ '"></strong>
                            <strong class="qb-single-receipt-odds" [textContent]="oddsValue" data-uat="odds" data-crlat="odds"></strong>
                            <div class="receipt-id">
                                <span [i18n]="'quickbet.betId'" data-crlat="betId.label"></span>
                                <span [textContent]="betReceipt.receipt" data-crlat="betId.value"></span>
                            </div>
                            <section class="qb-content-info" data-crlat="section.selections">
                                <ng-content select="your-call-body-receipt-details"></ng-content>
                            </section>
                            <div class="byb-event-name" [textContent]="bybEventName"></div>
                        </div>
                    </div>
                    <div class="right-section">
                        @if (isSportIconEnabled) {
                            <div class="sports-icon" [ngClass]="{ 'sports-icon-wrapper': winAlertsEnabled }">
                                <svg class="sports-icon-position">
                                    <use [attr.xlink:href]="'#' + sportIconSvgId"></use>
                                </svg>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

        <div class="promotion-icon-label icon-content" [ngClass]="{ alignLabelIcons: selection.categoryId == '16' }">
            @if (selection.categoryId == '16') {
                <promotion-icon
                    [type]="'market'"
                    [mode]="'sm'"
                    [display]="appendDrillDownTagNames(selection)"
                    [marketName]="selection.marketName"
                    [sport]="'sport'"
                    data-crlat="promotionIcons"
                    [disablePopUp]="true"
                    [isBetReceipt]="true">
                </promotion-icon>
            }

            <div class="promo-line">
                <!-- Promo labels -->
                <promo-labels
                    [cashoutValue]="betReceipt.bet?.cashoutValue"
                    [event]="selection"
                    [marketId]="selection.marketId"
                    [isBogEnabled]="isBogEnabled"
                    [exclude]="excludedDrillDownTagNames"
                    [mode]="'quickbet'"
                    [betslipSingleReceiptPromo]="true">
                </promo-labels>
            </div>
        </div>
        @if (winAlertsEnabled || betReceipt.footballAlertsVisible) {
            <div class="alerts-wrapper">
                <div class="notification-icon-wrapper fav-icon">
                    @if (betReceipt.footballAlertsVisible) {
                        <div class="match-alert-wrapper" (click)="onFootballBellClick()">
                            <span [i18n]="'bs.matchAlerts'"></span>
                            @if (betReceipt.footballBellActive) {
                                <svg>
                                    <use xlink:href="#bell-icon-on"></use>
                                </svg>
                            }
                            @if (!betReceipt.footballBellActive) {
                                <svg>
                                    <use xlink:href="#bell-icon-turn-off"></use>
                                </svg>
                            }
                        </div>
                    }
                </div>
                @if (winAlertsEnabled) {
                    <div class="right qb-win-alerts-wrapper">
                        <ng-container *ngTemplateOutlet="winAlertsTpl"></ng-container>
                    </div>
                }
            </div>
        }

        <div class="qb-stake-footer">
            <div class="line bs-stake-row summary-info">
                <span [i18n]="'quickbet.totalStake'" data-crlat="totalStake.label"></span>
                <span class="freebet-stake">
                    @if (selection.stakeAmount > 0) {
                        <span [textContent]="finalStake" data-crlat="totalStake"></span>
                    }
                </span>
                <span class="free-bet-label">
                    @if (hasFreebet) {
                        <free-bet-label
                            [plusPrefix]="selection.stakeAmount > 0"
                            [freeBetLabelText]="betReceipt.stake.freebetOfferCategory"
                            [selected]="betReceipt.stake.freebet">
                        </free-bet-label>
                    }
                </span>
            </div>
            <div class="line summary-info">
                <strong [i18n]="'quickbet.estimatedResults'" data-crlat="estimatedResults.label"></strong>
                <strong [textContent]="getPotentialPayoutValue(payout)" data-uat="estReturns" data-crlat="estimatedResults.value"></strong>
                @if (maxPayOutErrorService.maxPayFlag && maxPayOutFlag) {
                    <span
                        [ngClass]="{
                            'tooltipQB-max-payout-android': !!window?.nativeWindow?.NativeBridge,
                            'tooltipQB-max-payout': !window?.nativeWindow?.NativeBridge,
                        }">
                        <svg
                            class="maxPayOut-info-icon"
                            [tooltip]="'maxPayOutTitle'"
                            [showTooltip]="isMaxPayedOut"
                            [toolTipArgs]="maxPayOutErrorService.toolTipArgs"
                            [createElementTag]="true"
                            [gtmInfo]="'quick bet'"
                            (click)="togglemaxPayedOut()">
                            <use xlink:href="#icn-info"></use>
                        </svg>
                    </span>
                }
            </div>
        </div>
    </div>
    @if (nextRacesToBetslipToggle) {
        <lazy-component
            moduleUri="@lazy-modules-module/nextRacesToBetslip/nextraces-to-betslip.module#NextRacesToBetslipModule"
            [outputs]="['closeFn']"
            (event)="onQuickbetEvent()"
            [inputs]="{ quickBetReceipt: selection, racingPostData: racingPostData, isNextRacesData: isNextRacesData }">
        </lazy-component>
    }
</div>

<!-- Win alerts template -->
<ng-template #winAlertsTpl>
    <div class="qb-win-alerts-content">
        <div class="qb-win-alerts-info">
            <svg class="win-alerts-info-icon" [tooltip]="'winAlerts'" [showTooltip]="showWinAlertsTooltip()" (click)="handleAlertInfoClick()">
                <use xlink:href="#win-alert-icon"></use>
            </svg>
            <span [i18n]="'quickbet.winAlerts'"></span>

            <toggle-switch
                [initialState]="winAlertsActive"
                [componentId]="'toggle-switch-quick-bet'"
                [disabled]="!nativeBridge.pushNotificationsEnabled"
                (switcherControl)="toggleWinAlerts(betReceipt, $event)"
                (clickIfDisabled)="nativeBridge.showNotificationSettings()">
            </toggle-switch>
        </div>
    </div>
</ng-template>
